import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions as modalActions } from '@saucelabs/sl-container-modal';
import { operations as authOperations } from '@saucelabs/sl-container-authentication';

import AccountExpiredModal from '../components/AccountExpiredModal';
import { ACCOUNT_EXPIRED_MODAL_NAME } from '../constants';

class AccountExpired extends PureComponent {
  componentDidMount() {
    const { displayModal, showModal } = this.props;

    if (displayModal) {
      showModal(ACCOUNT_EXPIRED_MODAL_NAME);
    }
  }

  render() {
    const { wasSubscribed, handleLogout, isOrganizationOwner } = this.props;

    return (
      <AccountExpiredModal
        handleLogout={handleLogout}
        isOrganizationOwner={isOrganizationOwner}
        wasSubscribed={wasSubscribed}
      />
    );
  }
}

const mapStateToProps = ({ user }) => {
  const isOrganizationOwner = !user.get('parent');
  const wasSubscribed = user.get('was_subscribed');
  const wasTrial = user.get('was_trial');

  return ({
    displayModal: user.hasReadOnlyAccess() && (wasSubscribed || wasTrial),
    isOrganizationOwner,
    wasSubscribed,
  });
};

const mapDispatchToProps = {
  showModal: modalActions.showModal,
  handleLogout: authOperations.logout,
};

AccountExpired.propTypes = {
  displayModal: PropTypes.bool.isRequired,
  handleLogout: PropTypes.func.isRequired,
  isOrganizationOwner: PropTypes.bool.isRequired,
  showModal: PropTypes.func.isRequired,
  wasSubscribed: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountExpired);
export {
  AccountExpired,
  mapStateToProps,
  mapDispatchToProps,
};
